import axios from 'axios';
import GlobalData from './globalData';
import CLIENT_SECRET from './secret';

/* -------------------------------- Produzione -------------------------------- */
const BaseURL = 'https://api.hub.partitodemocratico.it/api';
// const BaseURL = 'https://api.partecipa.fourteentec.com/api';
/* ------------------------------- Sviluppo ------------------------------- */
// const BaseURL = 'https://api.dev.partecipa.fourteentec.com/api';
/* --------------------------------- Locale --------------------------------- */
// const BaseURL = process.env.BASE_URL || 'http://127.0.0.1:8000/api';

const API = axios.create({
  baseURL: BaseURL,
});

/**
 * Add a HTTP axios request interceptors
 */
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers['Client-Secret'] = CLIENT_SECRET;
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Add a HTTP axios response interceptors
 */
API.interceptors.response.use(
  (res) => res,
  (error) => {
    if (!error.response) return Promise.reject(error);

    const { status } = error.response;
    const originalRequest = error.config || {};

    if (status === 401 && !originalRequest.url?.includes('login') && !originalRequest.url?.includes('password')) {
      localStorage.clear();
      sessionStorage.clear();
      GlobalData.token = null;
      GlobalData.userData = null;
      GlobalData.loginData = null;
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

export default API;
export { BaseURL };
